<template>
  <!--nav>
    <router-link to="/">关于我们</router-link> |
    <router-link to="/article">文章</router-link> |
    <router-link to="/about">早知心介绍</router-link>|
    <router-link to="/XiSan">西山医院邀请码</router-link>|
    <router-link to="/basicAnalyse">个人身体概况分析</router-link>|
    <router-link to="/cardiovascular">心血管病风险分析</router-link>｜
    <router-link to="/informedConsent">知情同意书</router-link>|
    <router-link to="/privacyAgreement">隐私服务协议</router-link>|
    <router-link to="/userServiceAgreement">用户服务协议</router-link>|
    <router-link to="/chmed">中医体质</router-link>|
    <router-link to="/chmedAnalyse">体质结果</router-link>|
    <router-link to="/register">register</router-link>|
    <router-link to="/dataCenterList">dataCenterList</router-link>|
    <router-link to="/personAction">personAction</router-link>｜
    <router-link to="/userInfo?hopsId=60001">UserInfo</router-link>｜
    <router-link to="/personOrder">personOrder</router-link>｜
    <router-link to="/productDes">productDes</router-link>|
    <router-link to="/productList">productList</router-link>｜
    <router-link to="/bindingHosp">binding_hosp</router-link>｜
    <router-link to="/bindingStepHosp">bindingStepHosp</router-link>｜
    <router-link to="/userOrder">服务订单</router-link>|
    <router-link to="/doctorIndex">医生页</router-link>|
    <router-link to="/hospUser">体检科</router-link>|
    <router-link to="/userFinance">支付规划</router-link>｜
    <router-link to="/zhongyike/66999">中医科室</router-link>｜
    <router-link to="/articleList">文章列表</router-link>｜
    <router-link to="/article">文章</router-link>
  </nav-->
  <div id="app"  v-wechat-title="$route.meta.title">
    <router-view/>
  </div>
</template>
<style lang="less" scoped>
* {
  margin:0;
  padding:0;
 }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #F1F1F1;
  height: 100%;
}
</style>
